import { request } from '@/api'

export type ActivityPeriod = 'today' | '7d' | '30d'

export type ActivityLongWait = {
    memberId: string
    teammate: string
    waitingOn: string
    kind: 'decision' | 'plan' | 'stopped_run' | 'open_work' | 'plan_limit' | 'team_off'
    since: string
    /** The page that handles this kind of wait. */
    link: string
}

export type ActivityTeammate = {
    memberId: string
    name: string
    jobsFinished: number
    busyMs: number
    idleMs: number
    waitingOnYouMs: number
    waitingOnOtherMs: number
    runs: { succeeded: number; failed: number; cancelled: number; started: number }
    costUsdCents: number
}

export type ActivityReport = {
    period: ActivityPeriod
    windowStart: string
    windowEnd: string
    teammates: ActivityTeammate[]
    longestWaits: ActivityLongWait[]
}

/** The team Activity report (#2123), served under the `runs` grant. */
export const activityApi = {
    /** `GET /v1/activity?period=…` */
    report(period: ActivityPeriod): Promise<ActivityReport> {
        return request<ActivityReport>(`/v1/activity?period=${encodeURIComponent(period)}`)
    },
}
